import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import TourGuide from './components/TourGuide';
import TopBar from './components/TopBar';
import MetricCards from './components/MetricCards';
import TabBar from './components/TabBar';
import AlertsList from './components/AlertsList';
import AlertModal from './components/AlertModal';
import ChartHistory from './components/ChartHistory';
import useChartData from './hooks/useChartData';
import ClusterMap from './components/ClusterMap';
import PredictionHistory from './components/PredictionHistory';
import HowItWorks from './components/HowItWorks';

export default function App() {
  const [theme, setTheme]                 = useState('dark');
  const [activeTab, setActiveTab]         = useState('alerts');
  const [selectedAlert, setSelectedAlert] = useState(null);
  const { alerts, allAlerts, snapshotCount, todayCount, loading } = useChartData();

  const [runTour, setRunTour] = useState(false);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', 'dark');
  }, []);

  useEffect(() => {
    const toured = localStorage.getItem('chartpulse_toured');
    if (!toured) {
      setTimeout(() => setRunTour(true), 1200);
    }
  }, []);

  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    setTheme(next);
    document.documentElement.setAttribute('data-theme', next);
  };

  return (
    <div>
      <TopBar theme={theme} onToggleTheme={toggleTheme} />
      <MetricCards alertsData={alerts} allAlerts={allAlerts} snapshotCount={snapshotCount} todayCount={todayCount} />
      <TabBar activeTab={activeTab} onTabChange={setActiveTab} />

      <div className="main-content" style={{ padding: '16px 20px', background: 'var(--bg)', minHeight: '400px' }}>
        {loading ? (
          <p style={{ color: 'var(--muted)', fontSize: '13px' }}>Loading...</p>
        ) : (
          <AnimatePresence mode="wait">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.18, ease: 'easeInOut' }}
            >
              {activeTab === 'alerts'  && <AlertsList alerts={alerts} allAlerts={allAlerts} onAlertClick={setSelectedAlert} />}
              {activeTab === 'chart'   && <ChartHistory alerts={alerts} snapshotCount={snapshotCount} />}
              {activeTab === 'cluster' && (
                <ClusterMap
                  onAlertClick={setSelectedAlert}
                  alerts={alerts}
                />
              )}
              {activeTab === 'history' && <PredictionHistory allAlerts={allAlerts} />}
              {activeTab === 'hiw'     && <HowItWorks />}
            </motion.div>
          </AnimatePresence>
        )}
      </div>

    <TourGuide
        run={runTour}
        onEnd={() => {
          localStorage.setItem('chartpulse_toured', 'true');
          setRunTour(false);
        }}
      />
    <AlertModal alert={selectedAlert} alerts={alerts} allAlerts={allAlerts} onClose={() => setSelectedAlert(null)} />
    </div>
  );
}